import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { getAvailabilityTemplateByClientID_withLocation, getMasterData, saveAvailabilityTemplate_withLocation } from './actions/PatientActions';
import { renderCheckBox,renderDateField, renderTimePickerForStaffAvailbility } from '../../components/reduxFields';
import Alert from 'react-s-alert';

import _ from 'lodash';
import { CommonButton } from '../../components/buttons';

import { connect } from 'react-redux';
import moment from 'moment';
import React from 'react';
import history from '../../history';
// import validate from './validate';

const validate = values => {
  function validateNoOverlap(data) {
    // Helper function to sort intervals by StartTime
    function sortIntervals(intervals) {
        return intervals.sort((a, b) => new Date(a.StartTime).getTime() - new Date(b.StartTime).getTime());
    }

    // Iterate through the indices of the inner arrays
    const numIndexes = data[0].length;
    for (let i = 0; i < numIndexes; i++) {
        const intervalsAtIndex = [];

        // Collect intervals at the same index across all arrays
        for (const array of data) {
            const interval = array[i];
            if (interval && interval.StartTime && interval.EndTime) {
                const startTime = new Date(interval.StartTime).getTime();
                const endTime = new Date(interval.EndTime).getTime();

                // Check if StartTime is less than EndTime
                if (startTime >= endTime) {
                    return {
                        valid: false,
                        index: i,
                        message: `Invalid interval at index ${i}: StartTime must be less than EndTime`,
                    };
                }

                intervalsAtIndex.push(interval);
            }
        }

        // Sort intervals by StartTime
        const sortedIntervals = sortIntervals(intervalsAtIndex);

        // Check for overlaps among sorted intervals
        for (let j = 0; j < sortedIntervals.length - 1; j++) {
            const current = sortedIntervals[j];
            const next = sortedIntervals[j + 1];

            const currentEnd = new Date(current.EndTime).getTime();
            const nextStart = new Date(next.StartTime).getTime();

            // Check for overlap (next interval starts before the current interval ends)
            if (nextStart < currentEnd) {
                return {
                    valid: false,
                    index: i,
                    message: `Overlap detected at index ${i}`,
                };
            }
        }
    }

    return {
        valid: true,
        index: -1,
        message: "No overlaps detected",
    };
}

  const errors = { availabilityData: [] , unavailabilityData: [],weekData:[]};

  if(values.week){
    const validityResponse = validateNoOverlap(values.week)
    if(!validityResponse.valid){
      const dataErrors = {};
      dataErrors.weekData  = 'Please enter valid appointment end time';
      errors.weekData[validityResponse.index] = dataErrors; 
    }
   
  }

  if (values.availabilityData) { 
    values.availabilityData.forEach((data, index) => {
      const dataErrors = {}; 

      if (data.availabilityEndTime && data.availabilityStartTime) { 
        
        const startTime =  moment(data.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(data.availabilityStartTime).format('HH:mm:ss');
        const endTime = moment(moment(data.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(data.availabilityEndTime).format('HH:mm:ss'));
        let duration = moment.duration(endTime.diff(startTime));
        if (duration.asHours() <= 0) {
          dataErrors.availabilityEndTime  = 'Please enter valid appointment end time';
        }
      }

      if (Object.keys(dataErrors).length) { 
        errors.availabilityData[index] = dataErrors;
      }
    });
  }
  if (values.unavailabilityData) { 
    values.unavailabilityData.forEach((data, index) => {
      const dataErrors = {}; 

      if (data.unavailabilityEndTime && data.unavailabilityStartTime) { 
        
        const startTime =  moment(data.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(data.unavailabilityStartTime).format('HH:mm:ss');
        const endTime = moment(moment(data.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(data.unavailabilityEndTime).format('HH:mm:ss'));
        let duration = moment.duration(endTime.diff(startTime));
        if (duration.asHours() <= 0) {
          dataErrors.unavailabilityEndTime  = 'Please enter valid appointment end time';
        }
      }

      if (Object.keys(dataErrors).length) { 
        errors.unavailabilityData[index] = dataErrors; 
      }
    });
  }

  return errors; 
};
// const validate = (values, props) => {
//   const errors = {};
  
//   // Get initial values from props
//   const initialValues = props.initialValues;

//   // Check for new availability data
//   if (values.availabilityData && values.availabilityData !== initialValues.availabilityData) {
//     values.availabilityData.forEach((item, index) => {
//       if (!item.availabilityDate || !item.availabilityStartTime || !item.availabilityEndTime) {
//         errors.availabilityData = errors.availabilityData || [];
//         errors.availabilityData[index] = {
//           availabilityDate: !item.availabilityDate ? 'Required' : undefined,
//           availabilityStartTime: !item.availabilityStartTime ? 'Required' : undefined,
//           availabilityEndTime: !item.availabilityEndTime ? 'Required' : undefined,
//         };
//       }
//     });
//   }

//   // Check for new unavailability data
//   if (values.unavailabilityData && values.unavailabilityData !== initialValues.unavailabilityData) {
//     values.unavailabilityData.forEach((item, index) => {
//       if (!item.unavailabilityDate || !item.unavailabilityStartTime || !item.unavailabilityEndTime) {
//         errors.unavailabilityData = errors.unavailabilityData || [];
//         errors.unavailabilityData[index] = {
//           unavailabilityDate: !item.unavailabilityDate ? 'Required' : undefined,
//           unavailabilityStartTime: !item.unavailabilityStartTime ? 'Required' : undefined,
//           unavailabilityEndTime: !item.unavailabilityEndTime ? 'Required' : undefined,
//         };
//       }
//     });
//   }

//   // Additional validation for week data if needed
//   if (values.week && values.week !== initialValues.week) {
//     values.week.forEach((week, weekIndex) => {
//       week.forEach((day, dayIndex) => {
//         if (day.StartTime && day.EndTime && moment(day.EndTime).isBefore(moment(day.StartTime))) {
//           errors.week = errors.week || [];
//           errors.week[weekIndex] = errors.week[weekIndex] || [];
//           errors.week[weekIndex][dayIndex] = {
//             StartTime: 'End time must be after start time',
//             EndTime: 'End time must be after start time',
//           };
//         }
//       });
//     });
//   }

//   return errors;
// };
class AvailabilityTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      week: [],
      availabilityData: [],
      unavailabilityData: [],
      master_data: [],
      startOfficeTime: null,
      endOfficeTime: null,
      isEnableCheckForAllLocations: false,
      applyToAll: false,
      flagSave:true,
      formErrors: { availabilityData: [], unavailabilityData: [] },
    };
    this.onUnavailabilityDateChange = this.onUnavailabilityDateChange.bind(this);
    this.onAvailabilityDateChange = this.onAvailabilityDateChange.bind(this);
    this.renderAvailabilityTemplate = this.renderAvailabilityTemplate.bind(this);
    this.renderUnavailabilityTemplate = this.renderUnavailabilityTemplate.bind(this);
  };
  

  componentWillMount() {
    let week = [];
    let newWeek = [];
    let availabilityData = new Array(1).fill({ availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null });
    let unavailabilityData = new Array(1).fill({ unavailabilityDate: null, unavailabilityStartTime: null, unavailabilityEndTime: null });

    for (let i = 0; i < 7; i++) {
      newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
    }
    week.push(newWeek);
    this.setState({
      week: week,
      availabilityData: availabilityData,
      unavailabilityData: unavailabilityData,
    });

    if (this.props.patientId && this.props.selectedLocationId) {
      this.props.getAvailabilityTemplateByClientID_withLocation(this.props.patientId, this.props.selectedLocationId);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedLocationId && nextProps.selectedLocationId !== this.props.selectedLocationId) {
      let week = [];
      let newWeek = [];
      let availabilityData = new Array(1).fill({ availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null });
      let unavailabilityData = new Array(1).fill({ unavailabilityDate: null, unavailabilityStartTime: null, unavailabilityEndTime: null });

      for (let i = 0; i < 7; i++) {
        newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
      }
      week.push(newWeek);
      this.setState({
        week: week,
        availabilityData: availabilityData,
        unavailabilityData: unavailabilityData,
      });
      this.props.getAvailabilityTemplateByClientID_withLocation(nextProps.patientId, nextProps.selectedLocationId);
    }
    if (nextProps.clientAvailabilityData && this.props.clientAvailabilityData !== nextProps.clientAvailabilityData) {
      if (nextProps.initialValues && this.props.initialValues !== nextProps.initialValues) {
        this.setState({
          week: nextProps.initialValues.week,
          availabilityData: nextProps.initialValues.availabilityData,
          unavailabilityData: nextProps.initialValues.unavailabilityData,
          isDay: nextProps.initialValues.isDay,
          isEnableCheckForAllLocations: false,
        });
      }
    }

    if (nextProps.save_availability_template && this.props.save_availability_template !== nextProps.save_availability_template) {
      this.props.getAvailabilityTemplateByClientID_withLocation(nextProps.patientId, nextProps.selectedLocationId);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
      });
    }

    if (nextProps.officeHours && nextProps.officeHours !== this.props.officeHours) {
      // let startTime = nextProps.officeHours.data.startTime || '00:00:00',
      // endTime = nextProps.officeHours.data.endTime || '23:59:00',
      // startHour = startTime.substring(0, 2),
      // startMinutes = startTime.substring(3, 5),
      // endHour = endTime.substring(0, 2),
      // endMinutes = endTime.substring(3, 5);
    }

  };

  componentDidUpdate(prevProps, prevState) {
      // Check if clientAvailabilityData has changed
    if (prevProps.clientAvailabilityData !== this.props.clientAvailabilityData) {
      // Check if initialValues have changed
      if (this.props.initialValues && prevProps.initialValues !== this.props.initialValues) {
        this.setState({
          week: this.props.initialValues.week,
          availabilityData: this.props.initialValues.availabilityData,
          unavailabilityData: this.props.initialValues.unavailabilityData,
          isDay: this.props.isDay,
          isEnableCheckForAllLocations: false,
        });
      }
    }
  }
  
  onTimeChange(input, value, index,weekdata) {
   
    input.onChange(moment(value).format());
    let name = input.name;
    let weekData = this.state.week;
    let row = parseInt(name.slice(5, 6), 10);
    let column = parseInt(name.slice(8, 9), 10);
    let fieldName = name.slice(11);
    let dayIndexArray = this.props.master_data.masterWeekDays;
    let week = parseInt(weekdata.match(/\d+/)[0], 10);

    _.update(weekData, `[${row}][${column}].DayId`, function(n) {
      return dayIndexArray[index].id;
    });

    _.update(weekData, `[${row}][${column}].${fieldName}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    this.setState({
      week: weekData, 
    });


    if(fieldName==='StartTime'){
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].StartTime`,moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss')))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].EndTime`,weekData[week][index].EndTime))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].DayId`,dayIndexArray[index].id))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].id`,weekData[week][index].id))
    }
    if(fieldName==='EndTime'){
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].StartTime`,weekData[week][index].StartTime))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].EndTime`,moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss')))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].DayId`,dayIndexArray[index].id))
      this.props.dispatch(change('AvailabilityTemplateForm',`week[${week}][${index}].id`,weekData[week][index].id))
    }

  }

  handleWeekData = (e,weekIndex,index) => {
    let week = parseInt(weekIndex.match(/\d+/)[0], 10);
    let name = `week[0][${index}].StartTime`;
    let weekData = this.state.week;
    let row = parseInt(name.slice(5, 6), 10);
    let column = parseInt(name.slice(8, 9), 10);
    // let fieldName = name.slice(11); // This is not needed
    let dayIndexArray = this.props.master_data.masterWeekDays;
  
    if((this.state.applyToAll === true && index !== 1)) {

      _.update(weekData, `[${row}][${column}].DayId`, function(n) {
        return dayIndexArray[index].id;
      });

      _.update(weekData, `[${row}][${column}].StartTime`, function(n) {
        return weekData[0][1].StartTime
      });

      _.update(weekData, `[${row}][${column}].EndTime`, function(n) {
        return weekData[0][1].EndTime
      });

      this.setState({
        week: weekData, 
      });
    } else {
      _.update(weekData, `[${row}][${column}].DayId`, function(n) {
        return dayIndexArray[index].id;
      });

      _.update(weekData, `[${row}][${column}].StartTime`, function(n) {
        return;
      });

      _.update(weekData, `[${row}][${column}].EndTime`, function(n) {
        return;
      });

      this.setState({
        week: weekData, 
      });
    }

    if(!e.target.checked){
      for(let idx=0;idx<weekData.length;idx++){
        this.props.dispatch(change('AvailabilityTemplateForm',`week[${idx}][${index}].StartTime`,null))
        this.props.dispatch(change('AvailabilityTemplateForm',`week[${idx}][${index}].EndTime`,null))
        this.props.dispatch(change('AvailabilityTemplateForm',`week[${idx}][${index}].DayId`,null))
        this.props.dispatch(change('AvailabilityTemplateForm',`week[${idx}][${index}].id`,null))
      }
      let stateObj = [
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        },
        {
          "id": null,
          "StartTime": null,
          "EndTime": null,
          "DayId": null
        }
      ]
      this.setState({week:stateObj})
    }
  }

  onAvailabilityDateChange = (index, inputName, input, value) => {
    // let row = parseInt(input.name.slice(17, 18), 10);
    // let name = input.name.slice(20);
    let row = index;
    let name = inputName;   
    let availabilityData = this.state.availabilityData;

    _.update(availabilityData, `[${row}].${name}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });

    if (name === 'availabilityDate') {
      input.onChange(moment(value).format());
    }

    this.setState({ availabilityData: availabilityData });
    this.props.dispatch(change('AvailabilityTemplateForm', `availabilityData[${index}].${name}`, moment(value).format()));
  }

  onUnavailabilityDateChange = (index, inputName, input, value) => {
    // let row = parseInt(input.name.slice(19, 21), 10);
    // let name = input.name.slice(22);
    let row = index;
    let name = inputName;    
    let unavailabilityData1 = this.state.unavailabilityData;

    _.update(unavailabilityData1, `[${row}].${name}`, function(n) {
      return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
    });
    if (name === 'unavailabilityDate') {
      input.onChange(moment(value).format());
    }
    this.setState({ unavailabilityData: unavailabilityData1 });
    this.props.dispatch(change('AvailabilityTemplateForm', `unavailabilityData[${index}].${name}`, moment(value).format()));
    }

  // handleSaveAndSubmit = (formData) => {
  //   this.onSubmit(formData);
  //   history.push('/client-list');
  // }
  handleSaveAndSubmit = (formData) => {
    const errors = validate(formData);

    // Check if there are no validation errors
    if (!errors.availabilityData.length && !errors.unavailabilityData.length) {
      if(this.state.flagSave == true){
        this.onSubmit(formData);
        history.push('/client-list')
      }else{
        history.push('/client-list') 
      }
    } else {
   
      Alert.warning(`Please enter valid appointment end time`);
      // validate(formData)
    }
  }
  onSubmit = (formData) => {
    const errors = validate(formData);
    if (!errors.availabilityData.length && !errors.unavailabilityData.length && !errors.weekData.length){
      let formData1 = [];
    formData1.weekData = [];
    formData1.availabilityData = [];
    formData1.unavailabilityData = [];
    let week = this.state.week;
    this.state.week.map((obj, rowIndex) => {
      let x = Object.values(obj);
      if (x.length > 0) {
        x.forEach((value, colIndex) => {
          if (value === null && this.props.isDay && this.props.isDay[colIndex] === false) {
            _.update(week, `[${rowIndex}][${colIndex}].id`, function (n) {
              return null
            });
          }
          if (value !== null && this.props.isDay && this.props.isDay[colIndex] === false) {
            _.update(week, `[${rowIndex}][${colIndex}].id`, function (n) {
              return value.id
            });
            _.update(week, `[${rowIndex}][${colIndex}].DayId`, function(n) {
              return null;
            });
            _.update(week, `[${rowIndex}][${colIndex}].StartTime`, function(n) {
              return null;
            });
            _.update(week, `[${rowIndex}][${colIndex}].EndTime`, function(n) {
              return null;
            });
          }
          this.setState({
            week: week,
          });
        });
      };
      return true;
    });
    this.state.week.map((obj, rowIndex) => {
      let x = Object.values(obj);
      if (x.length > 0) {
        x.forEach((value, colIndex) => {
          if (value!==null&&value.EndTime && value.StartTime && value.DayId) {
            if (formData1.weekData.indexOf(value) === -1) {
              formData1.weekData.push(value);
            }
          }
        });
      }
      return formData1;
    });
    this.state.availabilityData.map((obj, index) => {
      if (obj.availabilityDate && obj.availabilityStartTime && obj.availabilityEndTime) {
        if (formData1.availabilityData.indexOf(obj) === -1) {
          formData1.availabilityData.push(obj);
        }

      }
      return formData1;
    });
    this.state.unavailabilityData.map((obj, index) => {
      if (obj.unavailabilityDate !== null && obj.unavailabilityStartTime !== null && obj.unavailabilityEndTime !== null) {
        if (formData1.unavailabilityData.indexOf(obj) === -1) {
          formData1.unavailabilityData.push(obj);
        }
      }
      return formData1;
    });

    let weekDataTypeID = null;
    let availabilityDataTypeID = null;
    let unavailabilityDataTypeID = null;
    if (this.props.master_data && this.props.master_data.staffAvailability && this.props.master_data.staffAvailability.length > 0) {
      this.props.master_data.staffAvailability.map((obj, index) => {
        if (obj.globalCodeName.toUpperCase() === 'weekDay'.toUpperCase()) {
          weekDataTypeID = obj.id;
        }
        if (obj.globalCodeName.toUpperCase() === 'available'.toUpperCase()) {
          availabilityDataTypeID = obj.id;
        }
        if (obj.globalCodeName.toUpperCase() === 'unavailable'.toUpperCase()) {
          unavailabilityDataTypeID = obj.id;
        }
        return { weekDataTypeID, availabilityDataTypeID, unavailabilityDataTypeID };
      });
    }
    formData1.weekDataTypeID = weekDataTypeID;
    formData1.unavailabilityDataTypeID = unavailabilityDataTypeID;
    formData1.availabilityDataTypeID = availabilityDataTypeID;

    formData1.PatientId = this.props.patientId;

    let filteredFormData = this.filterSubmittedData(formData1);


    let arrayOfObjForDays = []; 
    let arrayOfObjForAvailable = []; 
    let arrayOfObjForUnavailable = []; 

    if(
      this.props.isSameAvailabilityToAllLocations && this.props.staffLocationsList.data
    ){
      let excludedSelectLocationArray = [];
      if(this.props.staffLocationsList && this.props.staffLocationsList.data){
        let locationIds = this.props.staffLocationsList.data.map(d=>d.id);
        excludedSelectLocationArray = locationIds.filter(d=>d!=this.props.selectedLocationId);
      }
  
  
      excludedSelectLocationArray.forEach(id=>{
        let days = JSON.parse(JSON.stringify(filteredFormData.Days)); 
        let available = JSON.parse(JSON.stringify(filteredFormData.Available)); 
        let unavailable = JSON.parse(JSON.stringify(filteredFormData.Unavailable)); 
        days.forEach(obj=>{
          if(obj.Id === 0){
            arrayOfObjForDays.push({
              ...obj,
              Id:0,
              LocationId:id
            })
          }
        })

        available.forEach(obj=>{
          if(obj.Id === 0){
            arrayOfObjForAvailable.push({
              ...obj,
              Id:0,
              LocationId:id
            })
          }
        })
      
        unavailable.forEach(obj=>{
          if(obj.Id === 0){
            arrayOfObjForUnavailable.push({
              ...obj,
              Id:0,
              LocationId:id
            })
          }
        })
      })
    }

    let filteredFormDataCopy = {
      ...filteredFormData
    }

    if(this.props.isDefault && this.props.isSameAvailabilityToAllLocations){
      filteredFormDataCopy = {
        ...filteredFormData,
        Days:[...filteredFormData.Days,...arrayOfObjForDays],
        Available: [...filteredFormData.Available, ...arrayOfObjForAvailable],
        Unavailable: [...filteredFormData.Unavailable, ...arrayOfObjForUnavailable],
      }
    }




    // console.log(JSON.stringify(filteredFormData));
    this.props.saveAvailabilityTemplate_withLocation({...filteredFormDataCopy, isSameAvailabilityToAllLocations:this.props.isSameAvailabilityToAllLocations
    });
    this.setState({flagSave:false})
    }else{
      Alert.warning(`Please enter valid appointment end time`);
    }
    
  }


  // function to get insert/update staffAvailability Data with IsDeleted = true/false
  filterSubmittedData(formValues) {
    let weekData = formValues.weekData || [],
      availabilityData = formValues.availabilityData || [],
      unavailabilityData = formValues.unavailabilityData || []

    // add or update case for DaysAvailability
    let DaysAvailability = this.props.clientAvailabilityData && this.props.clientAvailabilityData.days ? this.props.clientAvailabilityData.days : [];
    DaysAvailability = DaysAvailability.map((obj) => {
      return {
        'Id': obj.id,
        'DayId': obj.dayId,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'ClientAvailabilityTypeID': obj.clientAvailabilityTypeID,
        'LocationId': obj.locationId,
        'IsDeleted': true,
      };
    });
    weekData.forEach((obj) => {
      // update case ------
      let dayData = DaysAvailability.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = DaysAvailability.indexOf(dayData);
        DaysAvailability[index] = {
          ...dayData,
          'DayId': obj.DayId,
          'StartTime': obj.StartTime,
          'EndTime': obj.EndTime,
          IsDeleted: false };
      } else {
        DaysAvailability.push({
          'Id': 0,
          'DayId': obj.DayId,
          'StartTime': obj.StartTime,
          'EndTime': obj.EndTime,
          'ClientAvailabilityTypeID': formValues.weekDataTypeID,
          'LocationId': this.props.selectedLocationId,
          'IsDeleted': false,
        });
      }
    });

    // add or update case for availabilityDates
    let availabilityDates = [];
    if (this.props.clientAvailabilityData && this.props.clientAvailabilityData.available) {
      availabilityDates = this.props.clientAvailabilityData.available;
    }
    availabilityDates = availabilityDates.map((obj) => {
      return {
        'Id': obj.id,
        'Date': obj.date,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'ClientAvailabilityTypeID': obj.clientAvailabilityTypeID,
        'LocationId': obj.locationId,
        'IsDeleted': true,
      };
    });
    availabilityData.forEach((obj) => {
      // update case ------
      let dayData = availabilityDates.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = availabilityDates.indexOf(dayData);
        availabilityDates[index] = {
          ...dayData,
          'Date': obj.availabilityDate,
          'StartTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityEndTime).format('HH:mm'),
          IsDeleted: false };
      } else {
        availabilityDates.push({
          'Id': 0,
          'Date': obj.availabilityDate,
          'StartTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.availabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.availabilityEndTime).format('HH:mm'),
          'clientAvailabilityTypeID': formValues.availabilityDataTypeID,
          'LocationId': this.props.selectedLocationId,
          'IsDeleted': false,
        });
      }
    });

    // add or update case for unAvailabilityDates
    let unAvailabilityDates = [];
    if (this.props.clientAvailabilityData && this.props.clientAvailabilityData.unavailable) {
      unAvailabilityDates = this.props.clientAvailabilityData.unavailable;
    }
    unAvailabilityDates = unAvailabilityDates.map((obj) => {
      return {
        'Id': obj.id,
        'Date': obj.date,
        'StartTime': obj.startTime,
        'EndTime': obj.endTime,
        'clientAvailabilityTypeID': obj.clientAvailabilityTypeID,
        'LocationId': obj.locationId,
        'IsDeleted': true,
      };
    });
    unavailabilityData.forEach((obj) => {
      // update case ------
      let dayData = unAvailabilityDates.find((Obj) => Obj.Id === obj.id && Obj.IsDeleted);
      if (dayData) {
        let index = unAvailabilityDates.indexOf(dayData);
        unAvailabilityDates[index] = {
          ...dayData,
          'Date': obj.unavailabilityDate,
          'StartTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityEndTime).format('HH:mm'),
          IsDeleted: false };
      } else {
        unAvailabilityDates.push({
          'Id': 0,
          'Date': obj.unavailabilityDate,
          'StartTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityStartTime).format('HH:mm'),
          'EndTime': moment(obj.unavailabilityDate).format('YYYY-MM-DD') + 'T' + moment(obj.unavailabilityEndTime).format('HH:mm'),
          'clientAvailabilityTypeID': formValues.unavailabilityDataTypeID,
          'LocationId': this.props.selectedLocationId,
          'IsDeleted': false,
        });
      }
    });

    // // is same availability repeat for the all locations ...
    // if (!this.props.staffAvailabilityData && this.props.isCheckForAllLocations) {
    //   let newDaysAvailability = [], newAvailabilityDates = [], newUnAvailabilityDates = [];
    //   (this.props.staffLocationsList || []).forEach((availObj) => {
    //     (DaysAvailability || []).forEach((obj) => {
    //       obj.LocationId = availObj.id;
    //       newDaysAvailability.push(obj);
    //     });
    //     (availabilityDates || []).forEach((obj) => {
    //       obj.LocationId = availObj.id;
    //       newAvailabilityDates.push(obj);
    //     });
    //     (unAvailabilityDates || []).forEach((obj) => {
    //       obj.LocationId = availObj.id;
    //       newUnAvailabilityDates.push(obj);
    //     });
    //   });
    //   DaysAvailability = newDaysAvailability;
    //   availabilityDates = newAvailabilityDatesl;
    //   unAvailabilityDates = newUnAvailabilityDates;
    // }

    let filteredFormData = {
      PatientId: formValues.PatientId,
      LocationId: this.props.selectedLocationId,
      Days: DaysAvailability,
      Available: availabilityDates,
      Unavailable: unAvailabilityDates,
    };
    return filteredFormData;
  }


  addWeekRow = () => {};
  removeWeekRow = (i) => {};
  addAvailabilityRow = () => {};
  removeAvailabilityRow = (i) => {};
  addUnavailabilityRow = () => {};
  removeUnavailabilityRow = (i) => {};
  renderWeekTemplate = ({ fields }) => {

    this.removeWeekRow = (i, e) => {
      fields.remove(i);
      let week = this.state.week;
      week.splice(i, 1);
      this.setState({
        week: week,
      });

    };
    this.addWeekRow = (e) => {
      fields.push({});
      let week = this.state.week;
      let newWeek = [];
      for (let i = 0; i < 7; i++) {
        newWeek.push({ StartTime: null, EndTime: null, DayId: null });
      }
      week.push(newWeek);
      this.setState({
        week: week,
      });
    };
    return (
      <div>
        {fields.map((week, index) =>
          <div key = {index}>
            <ul>
              {this.renderWeekDays(week, index)}
              <div>
                { (fields.length - 1) === index ?
                  <div>
                    {fields.length > 1 ?
                      (<button className="removeitem"
                        onClick={(e) => this.removeWeekRow(index, e)} type="button" title="Remove Row">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>)
                      : ''}
                    <button className="additem" onClick={this.addWeekRow} type="button" title="Add row">
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                  </div>
                  :
                  <div>
                    <button className="removeitem"
                      onClick={(e) => this.removeWeekRow(index, e)} type="button" title="Remove Row">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                }
              </div>
            </ul>
          </div>
        )
        }
      </div>
    );
  };
    renderAvailabilityTemplate = ({ fields }) => {
      const { formErrors } = this.state;
      this.removeAvailabilityRow = (i, e) => {
        fields.remove(i);
        let availabilityData = this.state.availabilityData;
        availabilityData.splice(i, 1);
        this.setState({
          availabilityData: availabilityData,
        });
        this.props.dispatch(change('AvailabilityTemplateForm', availabilityData[i], null));
      };

      this.addAvailabilityRow = (e) => {
        fields.push({});
        let availabilityData = this.state.availabilityData;
        let newData = { availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null };
        availabilityData.splice((this.state.availabilityData.length), 1, newData);
        newData = {};
        this.setState({
          availabilityData: availabilityData,
        });

      };
      return (
        <div>
          { fields.map((availabilityData, index) => {
            const availabilityEndTimeError =
            formErrors.availabilityData &&
            formErrors.availabilityData[index] &&
            formErrors.availabilityData[index].availabilityEndTime;
            return (
              <div className="availabletime" key = {index}>
                <div className="pdr-40 parent_div">

                  {this.renderAvailabilityData(availabilityData, index)}
                  {availabilityEndTimeError && (
                    <div className="error-message">
                      {availabilityEndTimeError}
                      <p>availabilityEndTimeError</p>
                    </div>
                  )}

                  <div>
                    { (fields.length - 1) === index ?
                      <div>
                        {fields.length > 1 ?
                          (<button className="removeitem"
                            onClick={(e) => this.removeAvailabilityRow(index, e)} type="button" title="Remove Row">
                            <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                          </button>)
                          : ''}
                        <button className="additem" onClick={this.addAvailabilityRow} type="button" title="Add row">
                          <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                        </button>
                      </div>
                      :
                      <div>
                        <button className="removeitem"
                          onClick={(e) => this.removeAvailabilityRow(index, e)} type="button" title="Remove Row">
                          <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>);
          }
          )}
        </div>
      );
    };
    renderAvailabilityData = (availabilityData, index) => {
      return (
        <div>

          <div key = {index} className ="row">
            <div className="col-sm-4">
              <Field
                name= {`${availabilityData}.availabilityDate`}
                placeholder="Availability Date"
                component={renderDateField}
                openToYearSelection = {true}
                selected={ this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? this.props.availabilityData[index].availabilityDate : null}
                onDateChange={(input, value) =>
                  this.onAvailabilityDateChange(index, 'availabilityDate', input, value)
                }
                locale="en-US"
                fullWidth={true}
              />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${availabilityData}.availabilityStartTime`}
                placeholder="Start Time"
                component={renderTimePickerForStaffAvailbility}
                disabled = {this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? false : true}
                selected={this.state.availabilityData && this.state.availabilityData[index] && this.state.availabilityData[index].availabilityStartTime ? this.state.availabilityData[index].availabilityStartTime : null}
                onDateChange={(input, value) =>
                  this.onAvailabilityDateChange(index, 'availabilityStartTime', input, value)
                }
                fullWidth={true}
              />
            </div>
            <div className="col-sm-4">
              <Field
                name={`${availabilityData}.availabilityEndTime`}
                placeholder="End Time"
                component={renderTimePickerForStaffAvailbility}
                disabled = {this.props.availabilityData && this.props.availabilityData[index] && this.props.availabilityData[index].availabilityDate ? false : true}
                selected={this.state.availabilityData && this.state.availabilityData[index] && this.state.availabilityData[index].availabilityEndTime ? this.state.availabilityData[index].availabilityEndTime : null}
                onDateChange={(input, value) => this.onAvailabilityDateChange(index, 'availabilityEndTime', input, value)}
                fullWidth={true}
              />
            </div>
          </div>
        </div>);
    }

  renderUnavailabilityTemplate = ({ fields }) => {
    this.removeUnavailabilityRow = (i, e) => {
      fields.remove(i);
      let unavailabilityData = this.state.unavailabilityData;
      unavailabilityData.splice(i, 1);
      this.setState({
        unavailabilityData: unavailabilityData,
      });
      this.props.dispatch(change('AvailabilityTemplateForm', unavailabilityData[i], null));
    };

    this.addUnavailabilityRow = (e) => {

      fields.push({});
      let unavailabilityData = this.state.unavailabilityData;
      let newData = {};
      newData = { unavailabilityDate: null, unavailabilityStartTime: null, unavailabilityEndTime: null };
      unavailabilityData.push(newData);
      this.setState({
        unavailabilityData: unavailabilityData,
      });

    };
    return (
      <div>

        { fields.map((unavailabilityData, index) => {
          return (
            <div className="unavailabletime" key = {index}>
              <div className="pdr-40 parent_div">

                {this.renderUnavailabilityData(unavailabilityData, index)}

                <div>
                  { (fields.length - 1) === index ?
                    <div>
                      {fields.length > 1 ?
                        (<button className="removeitem"
                          onClick={(e) => this.removeUnavailabilityRow(index, e)} type="button" title="Remove Row">
                          <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                        </button>)
                        : ''}
                      <button className="additem" onClick={this.addUnavailabilityRow} type="button" title="Add row">
                        <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                      </button>
                    </div>
                    :
                    <div>
                      <button className="removeitem"
                        onClick={(e) => this.removeUnavailabilityRow(index, e)} type="button" title="Remove Row">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>
                    </div>
                  }
                </div>

              </div>
            </div>);
        }
        )}
      </div>
    );
  };
  renderUnavailabilityData = (unavailabilityData, index) => {

    return (<div key = {index} className ="row">
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityDate`}
          placeholder="Unavailability Date"
          component={renderDateField}
          openToYearSelection = {true}
          selected={ this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? this.props.unavailabilityData[index].unavailabilityDate : null}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(index, 'unavailabilityDate', input, value)}
          locale="en-US"
          fullWidth={true}

        />
      </div>
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityStartTime`}
          placeholder="Start Time"
          component={renderTimePickerForStaffAvailbility}
          selected={ this.state.unavailabilityData && this.state.unavailabilityData[index] && this.state.unavailabilityData[index].unavailabilityStartTime ? this.state.unavailabilityData[index].unavailabilityStartTime : null}
          disabled ={this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? false : true}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(index, 'unavailabilityStartTime', input, value)}
          fullWidth={true}
        />
      </div>
      <div className="col-sm-4">
        <Field
          name={`${unavailabilityData}.unavailabilityEndTime`}
          placeholder="End Time"
          component={renderTimePickerForStaffAvailbility}
          selected={this.state.unavailabilityData && this.state.unavailabilityData[index] && this.state.unavailabilityData[index].unavailabilityEndTime ? this.state.unavailabilityData[index].unavailabilityEndTime : null}
          disabled ={this.props.unavailabilityData && this.props.unavailabilityData[index] && this.props.unavailabilityData[index].unavailabilityDate ? false : true}
          onDateChange={(input, value) => this.onUnavailabilityDateChange(index, 'unavailabilityEndTime', input, value)}
          fullWidth={true}
        />
      </div>
    </div>);
  }


  _isDefaultTab = (selectedLocationId) =>{
    let flag = false;
    let staffLocationsList = this.props.staffLocationsList;
    if(staffLocationsList && staffLocationsList.data && staffLocationsList.data.length){
      let staffLocationObj = staffLocationsList.data.find(d=>{
        return d.id == selectedLocationId
      })
      if(staffLocationObj){
        flag = staffLocationObj.isDefault;
      }
    }
    return flag;
  }

  handleApplyToAll = () => {
    this.setState({
      applyToAll : !this.state.applyToAll
    });
  }

  renderWeekDays = (week, dayIndex) => {
    dayIndex = dayIndex === undefined ? 0 : dayIndex;
    let weekArr = [{ day: 'Sun' }, { day: 'Mon' }, { day: 'Tue' }, { day: 'Wed' }, { day: 'Thr' }, { day: 'Fri' }, { day: 'Sat' }];
    return weekArr.map((obj, index) => {
      return (

        <li key={index}>
          {dayIndex === 0 ?
            <Field
              name={`isDay[${index}]`}
              label={obj.day}
              component={renderCheckBox}
              onChange={(e) => this.handleWeekData(e,week,index)}
              checked = {this.props.isDay && this.props.isDay[index] ? this.props.isDay[index] : false}
            />
            : ''}
          {this.renderTimes(week, index)}

        </li>
      );
    });
  };

 
  renderTimes = (week, index) => {
    let slicedWeekIndex = week.slice(5, 6);
    return (
      <div key={index}>

        <div>
          <Field
            name={`${week}[${index}].StartTime`}
            fullWidth={true}
            hintText="Start Time"
            component={renderTimePickerForStaffAvailbility}
            disabled = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? false : true}
            selected = { this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? (this.state.week[slicedWeekIndex] && this.state.week[slicedWeekIndex][index] && this.state.week[slicedWeekIndex][index].StartTime ? this.state.week[slicedWeekIndex][index].StartTime : null) : null}
            onDateChange={ (input, value) => this.onTimeChange(input, value, index,week)}
          />
          <Field
            name={`${week}[${index}].EndTime`}
            fullWidth={true}
            component={renderTimePickerForStaffAvailbility}
            hintText = "End Time"
            disabled = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? false : true}
            selected = {this.props.isDay && this.props.isDay[index] && this.props.isDay[index] === true ? (this.state.week[slicedWeekIndex] && this.state.week[slicedWeekIndex][index] && this.state.week[slicedWeekIndex][index].EndTime ? this.state.week[slicedWeekIndex][index].EndTime : null) : null}
            onDateChange={ (input, value) => this.onTimeChange(input, value, index,week)}

          />
        </div>
      </div>
    );
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <div className="clearfix"></div>
        <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit)}>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title mt-20">
                <h3>Week Days</h3>
                <div style={{ width: '500px', marginLeft: '40px', fontWeight:'500'}}>
                  <Field
                    name='applyToAll'
                    label='Apply Monday Availability for other weekday(s)'
                    component={renderCheckBox}
                    onChange={() => this.handleApplyToAll()}
                    checked={this.state.applyToAll}
                  />
                </div>
                <i className="flaticon flaticon-calendar"></i> 
                {
                  this._isDefaultTab(this.props.selectedLocationId) && (
                    <div style={{ width: '500px', marginLeft: '40px', fontWeight:'500'}}>
                      <Field
                          name='applyStaffAvailabilityToAllOffices'
                          label='Apply Staff availability to all the offices'
                          component={renderCheckBox}
                          onChange={() => this.props.handleApplyToStaffToOffice()}
                          checked={this.props.isSameAvailabilityToAllLocations}
                        />
                    </div>
                   )
                }
              </div>
              <div className="weekdayslist mt-20">
                <FieldArray name="week" component={this.renderWeekTemplate} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Availability Date and Time</h3>
                <i className="flaticon flaticon-calendar-1"></i>
              </div>

              <FieldArray name="availabilityData" component={this.renderAvailabilityTemplate} />

            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel_title">
                <h3>Unavailability Date and Time</h3>
                <i className="flaticon flaticon-interface"></i>
              </div>

              <FieldArray name="unavailabilityData" component={this.renderUnavailabilityTemplate} />

            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 mt-20">
              {this.state.isEnableCheckForAllLocations ?
                (<Field
                  name={'isCheckForAllLocations'}
                  label='Set this availability for all locations'
                  component={renderCheckBox}
                />)
                : null}
            </div>
            <div className="col-sm-6 pt20 btn_rt">
              {this.props.loading ?
                <CommonButton primary={true} className="loader_btn" disabled = {true } label= "Loading"/> : <CommonButton type="submit" primary={true} label= "Save"/>}
              <CommonButton className="ml_15" primary={true} label ="Submit" onTouchTap={handleSubmit(this.handleSaveAndSubmit)}/>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
const selector = formValueSelector('AvailabilityTemplateForm');
function mapStateToProps(state) {
  let week = [];
  let emptyWeek = [];
  let newWeek = [];
  let isDay = [7];
  for (let i = 0; i < 7; i++) {
    isDay[i] = false;
  }
  let availabilityData = [];
  let unavailabilityData = [];
  let emptyAvailabilityData = new Array(1).fill({ availabilityDate: null, availabilityStartTime: null, availabilityEndTime: null });
  let emptyUnavailabilityData = new Array(1).fill({ unavailabilityDate: null,
    unavailabilityStartTime: null,
    unavailabilityEndTime: null });
  let unavailabilityDate = null;
  let unavailabilityStartTime = null;
  let unavailabilityEndTime = null;
  let availabilityDate = null;
  let availabilityStartTime = null;
  let availabilityEndTime = null;
  for (let i = 0; i < 7; i++) {
    newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
  }
  emptyWeek.push(newWeek);
  function updatefunction(week, index, col, obj) {
    _.update(week, `[${index}][${col}].id`, function(n) {
      return obj.id;
    });
    _.update(week, `[${index}][${col}].DayId`, function(n) {
      return obj.DayId;
    });
    _.update(week, `[${index}][${col}].StartTime`, function(n) {
      return moment(obj.StartTime).format('YYYY-MM-DD') + 'T' + moment(obj.StartTime).format('HH:mm:ss');
    });
    _.update(week, `[${index}][${col}].EndTime`, function(n) {
      return moment(obj.EndTime).format('YYYY-MM-DD') + 'T' + moment(obj.EndTime).format('HH:mm:ss');
    });
  };
  function indexOfLongest(arrays) {
    var longest = -1;
    for (var i = 0; i < arrays.length; i++) {
      if (longest === -1 || arrays[i].length > arrays[longest].length) {
        longest = i;
      }
    }
    return longest;
  };
  function additionalData(week1) {
    let week = week1; // each single entry in multiple of 7
    let monData = [];
    let tueData = [];
    let wedData = [];
    let thrData = [];
    let friData = [];
    let satData = [];
    let sunData = [];

    if (week && week.length > 0) {
      week.map((item, index) => {
        if (!item.length && item.DayId && item.DayId !== undefined) {
          // console.log(item.attributes)
          switch (item.DayId) {
          case state.patient.patientMasterData.masterWeekDays[0].id:
            if (sunData.indexOf(item) === -1) {
              return sunData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[1].id:
            if (monData.indexOf(item) === -1) {
              return monData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[2].id:
            if (tueData.indexOf(item) === -1) {
              return tueData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[3].id:
            if (wedData.indexOf(item) === -1) {
              return wedData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[4].id:
            if (thrData.indexOf(item) === -1) {
              return thrData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[5].id:
            if (friData.indexOf(item) === -1) {
              return friData.push(item);
            }
            break;
          case state.patient.patientMasterData.masterWeekDays[6].id:
            if (satData.indexOf(item) === -1) {
              return satData.push(item);
            }
            break;
          default:
            return null;
          }
        } else {
          return false;
        }
        return { monData, tueData, wedData, thrData, friData, satData, sunData };
      });

      let arrays = [monData, tueData, wedData, thrData, friData, satData, sunData];
      let LongestArrayIndex = indexOfLongest(arrays);
      let week2 = new Array(arrays[LongestArrayIndex].length);
      let newWeek = [];
      for (let i = 0; i < week2.length; i++) {
        for (let j = 0; j < 7 ;j++)
          newWeek.push({ id: null, StartTime: null, EndTime: null, DayId: null });
        week2.splice(i, 1, newWeek);
        newWeek = [];
      }
      if (sunData.length > 0) {
        sunData.map((obj, index) => {
          let col = 0;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (monData.length > 0) {
        monData.map((obj, index) => {
          let col = 1;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (tueData.length > 0) {
        tueData.map((obj, index) => {
          let col = 2;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (wedData.length > 0) {
        wedData.map((obj, index) => {
          // console.log('wed data obj', obj)
          let col = 3;
          isDay[col] = true;
          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (thrData.length > 0) {
        thrData.map((obj, index) => {
          let col = 4;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (friData.length > 0) {
        friData.map((obj, index) => {
          let col = 5;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }
      if (satData.length > 0) {
        satData.map((obj, index) => {
          let col = 6;

          isDay[col] = true;

          updatefunction(week2, index, col, obj);
          return true;
        });
      }

      return week2;
    };
  };

  let clientAvailabilityData = null;

  if (state.patient.get_availability_template_by_id && state.patient.get_availability_template_by_id.data) {
    clientAvailabilityData = state.patient.get_availability_template_by_id.data;
    if (clientAvailabilityData.days) {
      clientAvailabilityData.days.map((obj, index) => {
        if (week.indexOf(obj) === -1) {
          week.push({
            id: obj.id,
            DayId: obj.dayId,
            StartTime: obj.startTime,
            EndTime: obj.endTime,
          });
        }
        return { week };
      });
    }

    if (clientAvailabilityData.available) {
      clientAvailabilityData.available.map((obj, index) => {
        if (availabilityData.indexOf(obj) === -1) {
          let id = obj.id;
          availabilityDate = obj.date;
          availabilityStartTime = obj.startTime;
          availabilityEndTime = obj.endTime;

          availabilityData.push({ id: id, availabilityDate: availabilityDate, availabilityStartTime: availabilityStartTime, availabilityEndTime: availabilityEndTime });
        }
        return { availabilityData };
      });
    }
    if (clientAvailabilityData.unavailable) {
      clientAvailabilityData.unavailable.map((obj, index) => {
        if (unavailabilityData.indexOf(obj) === -1) {
          let id = obj.id;
          unavailabilityDate = obj.date;
          unavailabilityStartTime = obj.startTime;
          unavailabilityEndTime = obj.endTime;
          unavailabilityData.push({ id: id, unavailabilityDate: unavailabilityDate, unavailabilityStartTime: unavailabilityStartTime, unavailabilityEndTime: unavailabilityEndTime });
        }
        return { unavailabilityData };
      });
    }
    week = additionalData(week);
  } else {

  }
  let initialValuesData = {
    week: week === undefined || !week[0] ? emptyWeek : week,
    availabilityData: availabilityData === undefined || !availabilityData[0] ? emptyAvailabilityData : availabilityData,
    unavailabilityData: unavailabilityData === undefined || !unavailabilityData[0] ? emptyUnavailabilityData : unavailabilityData,
    isDay: isDay,

  };

  return {
    saved_master_template: state.patient.saved_master_template,
    staffLocationsList: state.patient.staffLocationsList,
    get_availability_template_by_id: state.patient.get_availability_template_by_id,
    save_availability_template: state.patient.save_availability_template,
    master_data: state.patient.patientMasterData,
    officeHours: state.patient.officeHours,
    initialValues: initialValuesData,
    loading: state.patient.loading,
    clientAvailabilityData: clientAvailabilityData,
    availabilityData: selector(state, 'availabilityData'),
    unavailabilityData: selector(state, 'unavailabilityData'),
    isDay: selector(state, 'isDay'),
    week : selector(state,'week'),
    isCheckForAllLocations: selector(state, 'isCheckForAllLocations'),
  };
}
AvailabilityTemplate = reduxForm({
  form: 'AvailabilityTemplateForm',
  // validate,
  enableReinitialize: true,
})(AvailabilityTemplate);

export default connect(mapStateToProps, { getAvailabilityTemplateByClientID_withLocation, getMasterData, saveAvailabilityTemplate_withLocation})(AvailabilityTemplate);



// WEBPACK FOOTER //
// ./src/modules/patients/patient_availability.js